import React from 'react';
import CompetitionOpeningSoonIcon from '../../../../../../assets/svg/competition-opening-soon.svg';
import CompetitionClosedIcon from '../../../../../../assets/svg/competition-closed.svg';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import { styles } from './CompetitionClosed.css';

export type CompetitionClosedProps = {
  openingDate?: string;
};

type Content = {
  Image: React.FC;
  heading: string;
  Body: React.FC<{ openingDate?: string; shouldOverride?: boolean }>;
};

enum ContentVariants {
  openingSoon = 'openingSoon',
  closed = 'closed',
}

const content: Record<ContentVariants, Content> = {
  openingSoon: {
    Image: CompetitionOpeningSoonIcon,
    heading: 'Competition opening soon!',
    Body: ({ openingDate, shouldOverride }: { openingDate: string; shouldOverride: boolean }) =>
      shouldOverride ? (
        <>
          <p>This ballot will open on the {openingDate} at 10:00am AEST.</p>
        </>
      ) : (
        <>
          <p>
            This competition is not open yet but watch this space (page) as the entry form will be ready for you when
            the competition opens on {openingDate}.
          </p>
          <p>
            Feeling competitive while you wait? <a href="/blogs/competitions">Check out our other competitions</a>
          </p>
        </>
      ),
  },
  closed: {
    heading: 'Sorry, this competition has now closed.',
    Image: CompetitionClosedIcon,
    Body: () => (
      <>
        <p>
          Check our <a href="/blogs/competitions/competition-winners">winners section</a> if you’ve already entered.
          Otherwise, never miss a comp by bookmarking our <a href="/blogs/competitions">competitions home</a>.
        </p>
        <p>
          <JBButton type="primary" href="/blogs/competitions" label="View all competitions" />
        </p>
      </>
    ),
  },
};

export const CompetitionClosed = ({ openingDate }: CompetitionClosedProps) => {
  const pagePathname = window.location.pathname;
  const competitionPageSlugSetting = window.Jbhifi.competitionPageSlug;
  const shouldOverride = competitionPageSlugSetting
    ? pagePathname.includes(`/blogs/competitions/${competitionPageSlugSetting}`)
    : false;
  console.log('shouldOverride', shouldOverride);
  const { Image, heading, Body } = content[openingDate ? ContentVariants.openingSoon : ContentVariants.closed];
  const title = shouldOverride ? 'Ballot opening soon' : heading;

  return (
    <div className={styles.container}>
      <Image />
      <h3 className={styles.heading}>{title}</h3>
      <div className={styles.body}>
        <Body openingDate={openingDate} shouldOverride={shouldOverride} />
      </div>
    </div>
  );
};
